<template>
  <span class="group/tip relative inline-flex align-middle">
    <button type="button" class="text-gray-400 hover:text-gray-600 focus:text-gray-600 focus:outline-none" :aria-label="$gettext('Aide')">
      <QuestionMarkCircleIcon class="size-4" aria-hidden="true" />
    </button>
    <span
      role="tooltip"
      class="pointer-events-none absolute left-full top-1/2 z-30 ml-2 w-72 -translate-y-1/2 rounded-md bg-white p-3 text-sm font-normal normal-case text-gray-600 shadow-lg ring-1 ring-gray-200 opacity-0 transition-opacity duration-150 group-hover/tip:opacity-100 group-focus-within/tip:opacity-100"
    >
      {{ text }}
    </span>
  </span>
</template>

<script setup>
import { QuestionMarkCircleIcon } from "@heroicons/vue/24/outline";
import { useGettext } from "vue3-gettext";

const { $gettext } = useGettext();

defineProps({
  text: { type: String, required: true }
});
</script>
